// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1ZNjT","modalFooterButton":"ModalNotes_modalFooterButton__19X1Z"};